import { useEffect, useState } from "react";
import { MeshShell } from "@baditaflorin/mesh-common";
import { Pomodoro } from "./features/pomodoro/Pomodoro";
import { SettingsExtras } from "./features/settings/SettingsExtras";
import { appConfig } from "./shared/config";

const STORAGE = {
  room: `${appConfig.storagePrefix}:room`,
  focus: `${appConfig.storagePrefix}:focusMin`,
  brk: `${appConfig.storagePrefix}:breakMin`,
  rounds: `${appConfig.storagePrefix}:rounds`,
};

function readString(key: string, fallback: string): string {
  return localStorage.getItem(key) ?? fallback;
}
function readNumber(key: string, fallback: number): number {
  const raw = localStorage.getItem(key);
  if (raw === null) return fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
}

export function App() {
  const [roomId, setRoomId] = useState(() => readString(STORAGE.room, "default"));
  const [focusMin, setFocusMin] = useState(() => readNumber(STORAGE.focus, 25));
  const [breakMin, setBreakMin] = useState(() => readNumber(STORAGE.brk, 5));
  const [rounds, setRounds] = useState(() => readNumber(STORAGE.rounds, 3));

  useEffect(() => {
    localStorage.setItem(STORAGE.room, roomId);
  }, [roomId]);
  useEffect(() => {
    localStorage.setItem(STORAGE.focus, String(focusMin));
  }, [focusMin]);
  useEffect(() => {
    localStorage.setItem(STORAGE.brk, String(breakMin));
  }, [breakMin]);
  useEffect(() => {
    localStorage.setItem(STORAGE.rounds, String(rounds));
  }, [rounds]);

  return (
    <MeshShell
      config={appConfig}
      roomId={roomId}
      onRoomChange={setRoomId}
      settingsExtras={
        <SettingsExtras
          focusMin={focusMin}
          onFocusChange={setFocusMin}
          breakMin={breakMin}
          onBreakChange={setBreakMin}
          rounds={rounds}
          onRoundsChange={setRounds}
        />
      }
    >
      <Pomodoro roomId={roomId} focusMin={focusMin} breakMin={breakMin} rounds={rounds} />
    </MeshShell>
  );
}
